export default "__VITE_ASSET__6d4d9fe6__"